<template>
  <div class="ele-checklist ele-planlist">
    <div class="plan-left"> 
    <div @click="detail()">
      <p class="tit-ele-checklist">{{this.item.custname}}</p>
      <div class="node-plan"><p>序号:{{this.item.planid}}</p><p>销售员：{{this.item.salesmanName}}</p><p>计划访问时间：{{this.item.curvstdte}}</p></div>   
    </div>
  </div>   
    <button class="btn-delete-plan" @click="del()"><img src="../../assets/images/icon-delete-list.png" class="icon-delete-planlist" >删除</button>
    <p class="tag-ele-checklist bg-blue positon-l"
    v-if="this.item.custType!='N'">{{this.item.custType}}类</p>
    <p class="tag-ele-checklist bg-blue positon-l"
    v-if="this.item.custType=='N'">未合作</p>
  </div>
</template>


<script>
import visitPlanModel from '../../api/model/visit-plan'
import { mapState } from 'vuex'

export default {
  name: 'VisitPlanItem',
  data() {
    return {}
  },
  props: ['item'],
  methods: {
    detail() {
      this.$router.push('/visitPlanInfo/' + this.item.planid)
    },
    async del() {
      this.$dialog
        .confirm({
          title: '删除数据',
          message: '删除操作执行后将不可恢复，确认要删除该条过期数据吗？',
        })
        .then(() => {
          this.delSubmit()
        })
    },
   async delSubmit(){
     const param={
      id:this.item.planid,
     }
     const res=await visitPlanModel.delVisitPlan(param)
     if(res.success)
     {
      this.$toast('数据删除成功')
      location.reload()
      this.$router.push('/visitPlan')
     }
   }
  },
  computed: {
    ...mapState('systemAbout', ['clueParam']),
  },
}
</script>

<style scoped>
</style>